import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'tinper-bee';
import { observer } from 'mobx-react';
import _map from 'lodash/map';
import _truncate from 'lodash/truncate';
import {history} from 'mutants-microfx';
import { getFixedNumber } from './utils'


@observer
export default class extends Component {
    timer;
	constructor(props) {
        super(props);
        this.state={times:20}
	}

	static contextTypes = {
		stores: PropTypes.object
	};

	componentWillMount() {
		let { selfSettlementStore } = this.context.stores;
		this.store = selfSettlementStore;
	}

	componentDidMount() {
        this.timer=setInterval(()=>{
            let time=this.state.times-1;
            this.setState({times:time});
            if(time==0){
                history.push('/selfSettle');
            }
        }, 1000);
    }

    componentWillUnmount(){
        clearInterval(this.timer);
    }

    btnClick(){
        history.push('/selfSettle');
      }

	render() {
        let {amount,quantity,discount,member}=this.store;
		return (
        <div className="selfSettle">
            <div className="content">
                <div className="success">支付失败</div>
                <div className="welcome">请重新支付</div>
                <div className="paycontainer"><div className="payfailure"></div></div>
                {member && member.id &&<div className="member">
                    <span className="title">{member.type}</span>
                    <span className="value">{member.cardNo}</span>
                </div>}
                {member && member.id &&<div className="member">
                    <span className="title">余额</span>
                    <span className="value value2">{getFixedNumber(member.balance)}</span>
                </div>}
                <div className="seperator">
                    <div className="left"></div>
                    <div className="middle"></div>
                    <div className="right"></div>
                </div>
                <div className="total">
                    <span className="title">商品金额</span>
                    <span className="value">{getFixedNumber(Math.Add(amount,discount))}</span>
                </div>
                <div className="discount">
                    <span className="title">优惠金额</span>
                    <span className="value">{getFixedNumber(discount)}</span>
                </div>
                <div className="discount">
                    <span className="title">{`共${quantity}件`}</span>
                    <span className="value">{getFixedNumber(amount)}</span>
                </div>
                
                
                <div className="button failurebtn">
                    <Button onClick={this.btnClick}>{`重新支付（${this.state.times}s）`}</Button>
                </div>
            </div>
			
		</div>);
	}
}
